class BrandsFilter extends HTMLElement {
  constructor() {
    super();
    this.filterButtons = this.querySelectorAll('.bottone-filtro');
    this.mobileLetters = this.querySelectorAll('.mobile-letters');
    this.letterSections = this.querySelectorAll('.sezione-lettera');
    this.collectionLinks = this.querySelectorAll('a.link-collezione');
  }

  connectedCallback() {
    this.mobileLetters.forEach(letter => {
      letter.addEventListener('click', () => {
        this.mobileLetters.forEach(l => l.classList.remove('attivo'));
        letter.classList.add('attivo');
      });
    });

    this.filterButtons.forEach(button => {
      button.addEventListener('click', () => this.handleFilterClick(button));
    });
  }

  clearAll() {
    this.letterSections.forEach(section => section.classList.remove('hidden'));
    this.filterButtons.forEach(button => {
      button.classList.remove('CTABlack');
      button.classList.add('CTAOutline');
    });
  }

  handleFilterClick(button) {
    this.resetFiltersUI();
    this.resetCollectionLinksHref();

    if (button.id === 'filter-all') {
      this.handleFilterAllClick(button);
    } else {
      this.handleSpecificFilterClick(button);
    }
  }

  resetFiltersUI() {
    this.letterSections.forEach(section => section.classList.add('hidden'));
    this.filterButtons.forEach(btn => {
      btn.classList.remove('CTABlack');
      btn.classList.add('CTAOutline');
    });
  }

  resetCollectionLinksHref() {
    this.collectionLinks.forEach(link => {
      link.href = link.href.split('?')[0] + '?';
    });
  }

  handleFilterAllClick(button) {
    button.classList.replace('CTAOutline', 'CTABlack');
    this.showAllLinks();
  }

  handleSpecificFilterClick(button) {
    button.classList.toggle('CTAOutline');
    button.classList.toggle('CTABlack');

    const filterAll = this.querySelector('#filter-all');
    filterAll?.classList.replace('CTABlack', 'CTAOutline');

    const activeFilters = [...this.querySelectorAll('.bottone-filtro.CTABlack')];

    if (activeFilters.length === 0) {
      this.activateFilterAll(filterAll);
      return;
    }

    if (activeFilters.length === 1 && activeFilters[0].id === 'filter-all') {
      this.showAllLinks();
      return;
    }

    this.applyActiveFilters(activeFilters);
  }

  activateFilterAll(filterAll) {
    filterAll?.classList.replace('CTAOutline', 'CTABlack');
    this.showAllLinks();
  }

  showAllLinks() {
    this.collectionLinks.forEach(link => link.classList.remove('hidden'));
    this.letterSections.forEach(section => section.classList.remove('hidden'));
  }

  applyActiveFilters(activeFilters) {
    this.collectionLinks.forEach(link => link.classList.add('hidden'));

    const filtriAttivi = activeFilters.map(f => f.getAttribute('ftype'));
    const filtriAttiviUrl = activeFilters.map(f => f.getAttribute('ftypeUrl'));

    this.appendUrlFilters(filtriAttiviUrl);
    this.showMatchingLinks(filtriAttivi);
  }

  appendUrlFilters(filters) {
    this.collectionLinks.forEach(link => {
      const params = filters
        .map(f => {
            let genderFilter = '';
            switch (f) {
              case 'unisex':
                genderFilter = 'Unisex';
                break;
              case 'men':
                genderFilter = 'Man';
                break;
              default:
                genderFilter = 'Woman';
            }
            return `filter.p.m.elastick.gender=${genderFilter}`
        })
        .join('&');
      link.href += params + '&';
    });
  }

  showMatchingLinks(filters) {
    const linksWithFilters = this.querySelectorAll('a.link-collezione[collection-filters]');

    linksWithFilters.forEach(link => {
      console.log(link);
      const tags = link.getAttribute('collection-filters').split(', ');
      const lettersParent = link.getAttribute('letters');
      if (tags.some(tag => filters.includes(tag))) {
        link.classList.remove('hidden');
        try {
          this.querySelector(`.sezione-lettera-${CSS.escape(lettersParent)}`)?.classList.remove('hidden');
        } catch (e) {
          // Fallback for special characters in class names
          this.querySelectorAll('.sezione-lettera').forEach(section => {
            if (section.classList.contains(`sezione-lettera-${lettersParent}`)) {
              section.classList.remove('hidden');
            }
          });
        }
      }
    });
  }
}

customElements.define('brands-filter', BrandsFilter);
